import React from 'react';
import { useFormContext } from 'contexts/FormContext';

/**
 * Renders a form input with a label and an error message.
 *
 * @param {Object} props - The component's props.
 * @param {string} props.label - The input's label text.
 * @param {string} props.id - The input's id attribute.
 * @param {string} props.placeholder - The input's placeholder text.
 * @param {string} [props.type='text'] - The input's type attribute.
 * @param {string} [props.customClass=''] - Additional CSS class to apply to the container.
 * @returns {React.Component} The FormInput component.
 */
const FormInput = ({
  label,
  id,
  placeholder,
  type = 'text',
  customClass = '',
}) => {
  const { data, errors, handleChange, handleBlur } = useFormContext();

  return (
    <div className={`form-input-container ${customClass}`}>
      <label className='label' htmlFor={id}>
        {label}
      </label>
      <input
        className='input'
        name={id}
        type={type}
        id={id}
        value={data[id]}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
      />
      <p className='error'>{errors[id]}</p>
    </div>
  );
};

export default FormInput;
